// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"9c400d30","498":"cafbd9aa","703":"d8c6ad2e","787":"07be5fb2","820":"80498cef"}[chunkId] + ".chunk.js";
};